/* istanbul ignore file */
import { combineReducers } from '@reduxjs/toolkit';
import { produce } from 'immer';

import admin from './admin.slice';
import auth from './auth.slice';
import blog from './blog.slice';
import box from './box.slice';
import cart from './cart.slice';
import categ from './categ.slice';
import checkout from './checkout.slice';
import expro from './expro.slice';
import form from './form.slice';
import gui, { initialState as initialGuiState } from './gui.slice';
import notebook from './notebook.slice';
import primeur from './primeur.slice';
import product from './product.slice';
import root from './root.slice';
import storage from './storage.slice';
import toast from './toast.slice';
import user from './user.slice';
import wishList from './wishList.slice';
import newsletter from './newsletter.slice';
import assistant from './assistant.slice';
import { isObjectEmpty } from '@/utils/comparisonUtils';
import { LocalStorageService } from '@/services/LocalStorage.service';
import { PENDING_REQUEST } from '@/redux/thunks/checkout/validatePayment';

const appReducers = combineReducers({
  admin,
  auth,
  blog,
  box,
  cart,
  categ,
  checkout,
  expro,
  form,
  gui,
  notebook,
  primeur,
  product,
  root,
  storage,
  toast,
  user,
  wishList,
  newsletter,
  assistant
});

export type AppReducer = typeof appReducers;

// /**
//  * Do reducers hydratation at top level
//  * @param {*} state The app state
//  * @param {*} action The dispatched action
//  * @return {object} The new app state
//  */
export const reducer: AppReducer = (state, action) => {
  if (action.type === 'HYDRATE') {
    const incoming = structuredClone(action.payload) as ReturnType<AppReducer>;
    const nextState = produce(state, (draft) => {
      if (state.gui.isMobileDevice !== initialGuiState.isMobileDevice) {
        incoming.gui.isMobileDevice = state.gui.isMobileDevice;
      }

      const pendingProduct = state.wishList?.pendingProductIdForWishList;
      if (
        pendingProduct &&
        !incoming.wishList?.content?.includes(pendingProduct)
      ) {
        incoming.wishList.pendingProductIdForWishList = pendingProduct;
      }

      if (isObjectEmpty(incoming?.primeur?.primeurUser) && state.primeur?.primeurUser) {
        incoming.primeur.primeurUser = state.primeur.primeurUser;
      }

      const isGuest = incoming.auth?.loggedUser?.isGuest;
      if (isGuest === false && !pendingProduct) {
        incoming.wishList.content = state.wishList?.content;
      }

      if (
        incoming.checkout?.paymentProvider?.label === '' &&
        state.checkout?.paymentProvider?.label
      ) {
        incoming.checkout.paymentProvider.label = state.checkout.paymentProvider.label;
      }

      if (state.assistant?.modal?.opened && !incoming.assistant?.modal?.opened) {
        incoming.assistant.modal.opened = true;
      }

      const cartId = incoming.cart.content.id;
      const paymentProcessing = state.checkout.paymentStatus.status === 'pending';

      if (!isObjectEmpty(LocalStorageService.get(cartId)) && LocalStorageService.get(cartId) !== '' && paymentProcessing) {
        incoming.checkout.paymentStatus.status = 'pending';
      }
      Object.assign(draft, incoming);
    });

    return appReducers(nextState, action);
  }
  return appReducers(state, action);
};
